var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formitem-wapper',{attrs:{"formitem":_vm.formitem}},[_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([_vm.formitem.key,_vm.formitem.hiddenProp]),expression:"[formitem.key,formitem.hiddenProp]"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }